import {
  ODataHeader,
  ODataString,
  ODataEnum,
  ODataBoolean,
  ODataInteger,
  ODataDecimal
} from "pbas-vue-components";
import { translate2 } from "../trans2";
import { i18n } from "@/plugins/i18n";
import { translate } from "../trans";
import store from "@/store";

function getBenefitHeaders(coverage) {
  const headers = [
    new ODataHeader({
      title: "Id",
      type: new ODataString("Id"),
      sortable: true,
      visible: false,
      searchable: false,
      isIdentifier: true,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      type: new ODataString("Name"),
      sortable: true,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      title: "globals.name",
      type: new ODataString("Translations[]/Name", {
        getString: (item) => translate2(item, "Name"),
      }),
      sortable: false,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      type: new ODataString("Translations[]/LanguageCode"),
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      title: "globals.coverage",
      type: new ODataEnum("Coverage", {
        getString: (item) => {
          return i18n.t("enums." + item.Coverage);
        },
        dropdownItems: coverage,
      }),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "globals.category",
      type: new ODataString("Category"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.employer_files.code",
      type: new ODataString("Code"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.benefits_index.final_procedure",
      type: new ODataBoolean("FinalProcedure"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.benefits_index.treatment_site",
      type: new ODataString("TreatmentSite/Name", /*{
        getString: (item) => {
          if (item.TreatmentSite === null || item.TreatmentSite === undefined) {
            return "";
          }
          return `${item.TreatmentSite} ${item.Code}`
        },
      }*/),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      type: new ODataString("TreatmentSite/Code"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false
    }),
    new ODataHeader({
      type: new ODataString("TreatmentSite/Id"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      type: new ODataString("TreatmentSiteId"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      title: "headers.benefits_index.surfaces_required",
      type: new ODataBoolean("SurfacesRequired"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.benefits_index.no_of_surfaces_allowed",
      type: new ODataInteger("NoOfSurfacesAllowed"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.benefits_index.unit_value",
      type: new ODataDecimal("UnitValue"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.benefits_index.is_prescription_drugs",
      type: new ODataBoolean("IsPrescriptionDrugs"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.benefits_index.requires_din",
      type: new ODataBoolean("RequiresDIN"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.benefits_index.unit_group_category",
      type: new ODataString("UnitGroupCategory"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
  ];
  return headers;
}
export default getBenefitHeaders;
